import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const useRoutePrefix = (): string => {
  const [routePrefix, setRoutePrefix] = useState('');
  const { pathname } = useLocation();

  useEffect(() => {
    const isHomeDashboard = pathname === '/';
    const isEmployeeSelfService = pathname.includes('/ess/');
    const isMaterialRequest = pathname.includes('/mr/');

    if (isHomeDashboard) {
      setRoutePrefix('ess');
    }

    if (isEmployeeSelfService) {
      setRoutePrefix('ess');
    }

    if (isMaterialRequest) {
      setRoutePrefix('mr');
    }
  }, [pathname]);

  return routePrefix;
};

export default useRoutePrefix;
